import { gql } from '@apollo/client';

export const GET_PROGRAMME_MONITORINGFORMDATA = gql`
  query GetProgrammeMonitoringFormData($input: GetProgrammeMonitoringFormDataInput!) {
    monitoringFormData: getProgrammeMonitoringFormData(input: $input) {
      id
      submission {
        id
        status
        urls {
          id
          link
          name
        }
      }
      indicator {
        id
        name
        indicatorLabel
      }
      periodNumber
      dimensionReporter {
        id
        funder {
          id
          name
        }
        serviceProvider {
          id
          name
        }
        institution {
          id
          name
        }
      }
      dimension1
      dimension2
      dimension3
      dimension4
      dimension5
      value
      annotation
      progressStatus
      site {
        id
        name
      }
    }
  }
`;
